import type { UserManager } from 'oidc-client-ts';
import { endRevealSession } from '../variables/reveal';

/** What sign-out needs of the user manager. */
export type SignOutManager = Pick<UserManager, 'signoutRedirect' | 'removeUser'>;

/**
 * Sign-out (spec 6.1, 6.10.18): revealed values hide and the reveal choices are forgotten first, synchronously,
 * then the redirect to the identity provider. When the redirect can't start (no `end_session_endpoint`, the
 * metadata unreachable), the user is removed locally and the app reloads at its root, so the page never stays
 * on a signed-out user.
 */
export function signOut(
  userManager: SignOutManager,
  reload: () => void = () => window.location.assign('/'),
): Promise<void> {
  endRevealSession();
  return userManager.signoutRedirect().catch(async () => {
    try {
      await userManager.removeUser();
    } catch {
      // Nothing more to remove.
    }
    reload();
  });
}
